
import { Injectable }            from '@angular/core';
import {DocumentWindowManager} from "@/screens/ide/document.window.manager";
import {DocumentMetadata} from "@/screens/ide/document.metadata";
import {DocumentWindow} from "@/screens/ide/document.window";
import {Observable, Subject} from "rxjs";
import {WindowType} from "@/screens/ide/window";


@Injectable({
  providedIn: 'root'
})

/**
 *
 * @class WindowService
 *
 * Common window helpers like launching a new window panel of given kind.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export class WindowService {

  /** the controller for the main group of tabbed views in the center of the GUI */
  private documents: DocumentWindowManager = null;

  /** source for window toggle changes */
  private subject = new Subject<WindowType>();



  constructor() {


  }

  /** subscribe to window toggle requests */
  onWindowToggle(): Observable<WindowType> {

    return this.subject.asObservable();
  }

  /** toggle a window open/close */
  toggleWindow(type: WindowType): WindowService {

    /* notify the project manager that it needs to toggle this window */

    this.subject.next(type);

    return this;
  }

  /** give the service a reference to the central document tabs */
  setDocumentManager(documents: DocumentWindowManager): WindowService {

    this.documents = documents;

    return this;
  }

  /** launch a tab, but try to use the anchored window for this kind window */
  refocus(params: DocumentMetadata, append: boolean = false): WindowService {

    const anchor: DocumentWindow = this.documents.anchor(params.type);

    if (anchor == null) {

      /*
       * there is no anchor for this group of windows right now, either none exist, or
       * none are set to anchor, in that case, just launch a new tab as usual.
       *
       */

      this.launchWindow(params);

      return ;
    }

    /*
     * since one of that kind of window is currently the anchor or the default window
     * to use...send the request there...
     *
     */

    this.documents.raiseWindow(anchor);

    anchor.refocus(params, append);

    return this;
  }

  /** add a new tab to the central part of the GUI */
  launchWindow(params: DocumentMetadata): WindowService {

    if (this.documents) {

      this.documents.launch(params);
    }

    return this;
  }


}
